// Shared terrain tuning. Scale means diameter/radius multiplier, not cubic volume.
// R7 pairing has no independent size multiplier: its mood event is authoritative.
export const AFFECTED_SCALE = 2.3;
export const MANUAL_TILT_LIMIT = 26 * Math.PI / 180;
export const WORLD_TILT_LIMIT = 28 * Math.PI / 180;
export const AUTO_TILT_LIMIT = 23 * Math.PI / 180;
export const SURFACE_MIN = -.58;
export const SURFACE_MAX = .68;
export const UNSTABLE_SUBSTRATE_Y = -.68;
export function limitTilt(pitch,roll,limit=WORLD_TILT_LIMIT){
 const size=Math.hypot(pitch,roll),factor=size>limit?limit/size:1;
 return {pitch:pitch*factor,roll:roll*factor};
}
